import { generateMedia } from "styled-media-query";

export const Small: number = 576;
export const Medium: number = 768;
export const Large: number = 992;
export const ExtraLarge: number = 1200;
export const ExtraExtraLarge: number = 1400;

export const accountsMedia = generateMedia({
    Small: `${Small}px`,
    Medium: `${Medium}px`,
    Large: `${Large}px`,
    ExtraLarge: `${ExtraLarge}px`
})